module.exports = __webpack_public_path__ + "img/Oeste.8c85fff8.svg";